import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { JwtHelperService } from '@auth0/angular-jwt';

import { environment } from '@environments/environment';
import { GlobalDataService } from '@providers/global-data/global-data.service';
import { UtilsService } from '@providers/utils/utils.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private url: string;
  public token: string;

  constructor(
    public http: HttpClient,
    public jwtHelper: JwtHelperService,
    private globalDataService: GlobalDataService,
    private utils: UtilsService
  ) {
    this.url = `${environment.auth_url}/?redirect=`;
  }

  public isAuthenticated(): boolean {
    const token = this.jwtHelper.tokenGetter();

    if (typeof token !== 'undefined' && !this.jwtHelper.isTokenExpired(token)) {
      return true;
    }

    return false;
  }

  public redirectOAuth(): void {
    const currentUrl = document.URL;
    window.open(this.url + encodeURIComponent(currentUrl), '_self');
  }

  public retrieveTokenFromUrl(): void {
    const params = this.utils.extractUrlParams();

    if (params['token']) {
      localStorage.setItem('access_token', params['token']);
    }
  }
}
